// plan-08 S01/S04/S06 + plan-10 S03: portal widget public interface — bible §26
// Refactored: exports StageWidget for default card; engage triggers full descent overlay

import { playDescent, playAscent } from '../../audio/portal'
import { runDescent, removeDescent } from './descent'
import { mountIframe, unmountIframe } from './iframe'
import { load, bump } from '../../core/save'
import { getNetworkState } from '../../core/network'
import type { StageWidget, StageHandle, StageCtx } from '../stage/types'

let mounted = false

function engage(): void {
  if (mounted) return

  // plan-11 S05: offline portal — show immediate failure
  if (getNetworkState() === 'offline') {
    const stageBody = document.getElementById('vt-stage-body')
    if (stageBody) {
      const card = stageBody.querySelector('.vt-portal-offline') as HTMLElement | null
      if (!card) {
        const offlineCard = document.createElement('div')
        offlineCard.className = 'vt-portal-offline'
        offlineCard.style.padding = '12px'
        offlineCard.innerHTML = '<div style="color:var(--vt-amber);">> dream offline. proximity: probably.</div>'
        const retryBtn = document.createElement('button')
        retryBtn.className = 'vt-portal-btn'
        retryBtn.textContent = '[ retry ]'
        retryBtn.style.marginTop = '8px'
        retryBtn.addEventListener('click', () => {
          offlineCard.remove()
          engage()
        })
        offlineCard.appendChild(retryBtn)
        stageBody.appendChild(offlineCard)
      }
    }
    return
  }

  mounted = true
  bump('events')

  const s = load()
  const muted = s.audioMuted
  const mq = window.matchMedia('(prefers-reduced-motion: reduce)')
  const reduced = mq.matches

  if (!muted) playDescent()

  runDescent(reduced, () => {
    mountIframe({
      onAscend: () => ascend(),
      onFailure: () => {},
    })
  })
}

function ascend(): void {
  if (!mounted) return
  mounted = false

  const s = load()
  const muted = s.audioMuted
  const mq = window.matchMedia('(prefers-reduced-motion: reduce)')
  const reduced = mq.matches

  if (!muted) playAscent()

  unmountIframe()
  removeDescent(reduced, () => {})
}

// --- StageWidget implementation ---
// Portal shows a default card with [ engage ] button; clicking engage triggers the full descent overlay

export const portalWidget: StageWidget = {
  id: 'portal',
  label: 'UNDERNET PORTAL // VAGUE_SOULS',
  mount(host: HTMLElement, ctx: StageCtx): StageHandle {
    const card = document.createElement('div')
    card.style.cssText = 'padding: 12px;'

    const label = document.createElement('div')
    label.className = 'vt-portal-label'
    label.textContent = 'UNDERNET PORTAL // VAGUE_SOULS'
    card.appendChild(label)

    const tagline = document.createElement('div')
    tagline.className = 'vt-portal-tagline'
    tagline.textContent = '// the dream is the network. enter at your own consensus.'
    tagline.style.marginTop = '6px'
    card.appendChild(tagline)

    const btnRow = document.createElement('div')
    btnRow.className = 'vt-portal-btn-row'
    btnRow.style.marginTop = '12px'
    const btn = document.createElement('button')
    btn.className = 'vt-portal-btn'
    btn.textContent = '[ engage ]'
    btn.addEventListener('click', (e) => {
      e.stopPropagation()
      ctx.emitOracle('> portal opening. proximity: probably.')
      engage()
    })
    btnRow.appendChild(btn)
    card.appendChild(btnRow)

    host.appendChild(card)

    return {
      dismiss() {
        // card cleanup — the descent overlay handles itself
      },
    }
  },
}

export function triggerEngage(): void {
  engage()
}

// Legacy export for backward compat
export function mountPortal(_parent: HTMLElement): void {
  // no-op — portal is now a stage widget
}
